export default __webpack_public_path__ + "static/media/wave.b8fe47cf.less";